import { minLength, required, sameAs } from '@vuelidate/validators';

export const optionalRule = {
  $validator: (): boolean => true,
  $message: '',
};

export const AuthValidateRules = {
  phoneNumber: {
    minLength: { ...minLength(16), $message: 'Недействительный номер' },
    required: {
      ...required,
      $message: 'Обязательное поле',
    },
  },
  checkbox1: {
    sameAsTrue: sameAs(true),
    required: {
      ...required,
      $message: 'Обязательное поле',
    },
  },
  checkbox2: {
    sameAsTrue: sameAs(true),
    required: {
      ...required,
      $message: 'Обязательное поле',
    },
  },
};
